import { TabStyles } from '@tableau/widgets';

import { cssClass } from '~src/style';

const cssPrefix = 'GetServiceAccountFile';
export namespace AddServiceAccountDialogStyles {
  export const contentContainer = cssClass(cssPrefix, 'contentContainer', {
    display: 'flex',
  });

  export const innerContentContainer = cssClass(cssPrefix, 'inner-content-container', {
    flex: '1',
    minWidth: 0 // To contain text inside
  });

  export const fileSelectionContainer = cssClass(cssPrefix, 'file-container', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',height: '150px',
    marginBottom: '8px',
    border: '2px dashed #ccc',
    position: 'relative'
  });

  export const dragAndDropChildren = cssClass(cssPrefix, 'inner-container', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    zIndex: 1, // Elevate children above ::after
  });

  export const fileName = cssClass(cssPrefix, 'file-name', {
    color: TabStyles.Typography.Color.PrimaryMedium,
    marginTop: 0,
    marginBottom: '30px',
  });

  export const uploadServiceAccountFileDescription = cssClass(cssPrefix, 'upload-service-account-description', {
    color: TabStyles.Typography.Color.PrimaryLight,
    lineHeight: `${TabStyles.Typography.Sizing.XLarge}px`
  });
}
